import { render, staticRenderFns } from "./TprepSessionEdit.vue?vue&type=template&id=6ab354b0"
import script from "./TprepSessionEdit.vue?vue&type=script&lang=js"
export * from "./TprepSessionEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports